import { BULK_PRICES, SPECIAL_OPTION } from '../../constants';
import {
  ViewerAttributeInputInterface,
  ViewerAttributeInterface,
  ViewerGroupInputItemsInterface,
  ViewerGroupInterface,
  ViewerItemInterface,
  ViewerOptionInterface,
  ViewerOptionInterfaceInput,
  ViewerOptions,
} from '../../models';
import { CustomizationParams, FiltersType } from '../customizations';
import { instanceOfViewerGroupAttribute } from '../viewer-options';

const mapSearchingGroup = (group: ViewerGroupInterface, filters: FiltersType | undefined, onSelectedOption: (opt: ViewerItemInterface) => void) => {
  let filtered_groups: string[] | undefined = [];
  if (instanceOfViewerGroupAttribute(group) && filters) {
    group.attributes.map((attr) => {
      /**
       * This is a temp bug fix. In some combinations zakeke don't send a default option selected.
       * If no default option is selected, force to select the first one.
       * Or this filter will not work and show all the available groups
       */
      const selected = attr.options.filter((opt) => opt.selected);
      if (!selected.length) {
        onSelectedOption(attr.options[0]);
      }

      attr.options.map((opt: ViewerOptionInterface) => {
        if (opt.selected) {
          const optId = opt.id.toString();
          const filtered = filters.filter((flt) => flt.hasOwnProperty(optId));
          if (filtered.length) {
            filtered_groups = filtered[0][optId].groups;
          }
        }
      });
    });
  }

  return filtered_groups;
};

export const FilterGroupsByOption = (
  customizationParams: CustomizationParams | null,
  groups: ViewerGroupInterface[],
  onSelectedOption: (opt: ViewerItemInterface) => void
): ViewerGroupInterface[] => {
  // Get Params from customizations //
  const filter_by_attribute = customizationParams?.filter_by_attribute;
  const searching_groups_id = filter_by_attribute?.searching_groups;
  const filters = filter_by_attribute?.filters;
  if (!searching_groups_id || !searching_groups_id.length) return groups;

  let filtered_groups_ids: string[] | undefined = [];
  groups.map((grp) => {
    if (searching_groups_id.includes(grp.id)) {
      filtered_groups_ids = mapSearchingGroup(grp, filters, onSelectedOption);
    }
  });
  const new_groups = groups.filter((group) => {
    return filtered_groups_ids && !filtered_groups_ids.includes(group.id);
  });

  if (new_groups.length) return new_groups;
  else return groups;
};

export const mapSpecialGroup = (
  newViewerOptions: ViewerOptions,
  customizationParams: CustomizationParams | null,
  bulkData: ViewerGroupInputItemsInterface | null,
  setBulkData: (group: ViewerGroupInputItemsInterface) => void
) => {
  /* special group is separated */
  const specialGroup = getSpecialGroup(newViewerOptions.groups);
  if (!specialGroup) return newViewerOptions;

  // remove the special group from the groups array
  newViewerOptions.groups = newViewerOptions.groups.filter((group) => group.id !== specialGroup.id);

  // add the special group
  newViewerOptions.specialGroup = specialGroup;

  // now, lets handle the special group attributes

  /*
   * the special attribute A91 becomes a new special group
   * with input fields and so on
   */

  if (instanceOfViewerGroupAttribute(specialGroup)) {
    if (!specialGroup.attributes) return newViewerOptions;

    const urlParamsGet = new URLSearchParams(window.location.search);
    const customizationComposition = urlParamsGet.get('composition');
    const config = !!customizationComposition ? customizationParams?.bulkLimitConfigComposition : customizationParams?.bulkLimitConfig;

    const bulkPricesAttribute = specialGroup.attributes.find((attr) => attr.id === BULK_PRICES.BULK_PRICES_ATTRIBUTE_CODE);
    if (!bulkPricesAttribute) return newViewerOptions;

    // create attributes array
    const bulkPricesAttributes: ViewerAttributeInputInterface[] = bulkPricesAttribute.options.map((opt) => {
      return {
        id: opt.id.replace('M', 'A'),
        name: opt.name,
        options: getOptionsWithValue(specialGroup.attributes, opt),
        displayOrder: opt.displayOrder,
        imageUrl: opt.imageUrl,
        enabled: opt.enabled,
        selected: opt.selected,
        externalCode: opt.externalCode,
        cameraLocationId: null,
        isInput: true,
        groupId: Number(specialGroup.id),
        price: 0,
        minAmount: config?.find((c) => c.category.includes(opt.id.replace('M', 'A')))?.minimum || 0,
      };
    });

    const parentedAttributes = setParent(bulkPricesAttributes);

    // create a new group
    const bulkPricesGroup: ViewerGroupInputItemsInterface = {
      id: BULK_PRICES.BULK_PRICES_GROUP_CODE,
      name: bulkPricesAttribute.name,
      attributes: parentedAttributes,
      externalCode: specialGroup.externalCode,
      imageUrl: specialGroup.imageUrl,
      enabled: specialGroup.enabled,
      cameraLocationId: null,
      displayOrder: specialGroup.displayOrder,
      categoryOptions: bulkPricesAttribute.options,
    };

    // set the bulk data
    if (!bulkData) setBulkData(bulkPricesGroup);

    // add the new group to the groups array
    newViewerOptions.groups.push(bulkPricesGroup);

    // push the group with id Other to the end
    newViewerOptions.groups = newViewerOptions.groups.sort((a, b) => {
      if (a.id === 'Other') return 1;
      if (b.id === 'Other') return -1;
      return a.displayOrder - b.displayOrder;
    });

    return newViewerOptions;
  } else return newViewerOptions;
};

const setParent = (attributes: ViewerAttributeInputInterface[]): ViewerAttributeInputInterface[] => {
  return attributes.map((attr, index) => {
    return {
      ...attr,
      options: attr.options.map((opt) => {
        return {
          ...opt,
          value: opt.selected && index === 0 ? 1 : 0,
          parent: attr,
        };
      }),
    };
  });
};

const getOptionsWithValue = (attributes: ViewerAttributeInterface[], opt: ViewerOptionInterface): ViewerOptionInterfaceInput[] => {
  const attribute = attributes.find((attr) => attr.id.replace('A', 'M') === opt.id) as ViewerAttributeInputInterface;
  if (!attribute) return [];

  // we want to add a custom property to the option
  return attribute.options.map((opt) => {
    return {
      ...opt,
      value: 0,
    };
  });
};

/* special group is separated */
const getSpecialGroup = (groups: ViewerGroupInterface[]): ViewerGroupInterface | undefined => {
  const specialGroup = groups.find((group) => group.id === SPECIAL_OPTION.INVISIBLE_GROUP);
  return specialGroup;
};
